import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import updateServiceAssignment from './updateServiceAssignment';
import * as serviceAssignmentActionTypes from '../serviceAssignmentActionTypes';

/**
 * Update Service case alternative provider data
 */
const updateAlternativeServiceProvider = function* updateAlternativeServiceProvider() {
    while (true) {
        const {payload} = yield take(serviceAssignmentActionTypes.SUBMIT_ALTERNATIVE_SERVICE_PROVIDER_FORM);
        const {serviceAssignmentLineNo, serviceCaseId, assignmentType, serviceAssignmentData} = payload;

        yield* updateServiceAssignment({
            caller: serviceAssignmentActionTypes.SUBMIT_ALTERNATIVE_SERVICE_PROVIDER_FORM,
            assignmentType: assignmentType,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: serviceAssignmentActionTypes.SUBMIT_ALTERNATIVE_SERVICE_PROVIDER_FORM},
        });
    }
};

export default updateAlternativeServiceProvider;
